var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PersonDone = function PersonDone(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7Zm5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M7 16a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-3-3H7ZM22.707 9.707a1 1 0 0 0-1.414-1.414L18 11.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default PersonDone;